import React from 'react';

import { Props } from './searchable-select.config';
import Select, { SelectProps } from 'antd/es/select';

const SearchableSelect = ({
  children,
  notSorted = false,
  filterField = 'children',
  isOptGroup = false,
  localOptions = undefined,
  // maxTagCount = 10,
  ...innerProps
}: Props & SelectProps): JSX.Element => {
  return (
    <Select
      showSearch
      // @ts-ignore
      filterOption={(input, option) => {
        if (notSorted) {
          if (option) {
            if (isOptGroup) {
              const optionLabel = option.label?.toString();
              if (optionLabel) {
                return optionLabel.toLowerCase().includes(input.toLowerCase()) ?? false;
              }
            }

            const optionFilter = filterField as keyof typeof option;
            if (option[optionFilter]?.toLowerCase) {
              // @ts-ignore
              return option[optionFilter].toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }
            if (!Number.isNaN(option[optionFilter])) {
              // @ts-ignore
              return option[optionFilter].toString().indexOf(input.toLowerCase()) >= 0;
            }
          }
          return undefined;
        }

        if (input && localOptions && localOptions.length > 0) {
          return localOptions
            .filter((o) => o.value === option?.value)
            .some((o) => o.text.toLowerCase().includes(input.toLowerCase()));
        }
        if (option) {
          const optionFilter = filterField as keyof typeof option;
          if (option[optionFilter]?.toLowerCase) {
            // @ts-ignore
            return option[optionFilter].toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }
          if (!Number.isNaN(option[optionFilter])) {
            // @ts-ignore
            return option[optionFilter].toString().indexOf(input.toLowerCase()) >= 0;
          }
        }
        return undefined;
      }}
      filterSort={
        notSorted
          ? undefined
          : (optionA, optionB) => {
              if (optionA && optionB) {
                const optionFilter = filterField as keyof typeof optionA;
                // @ts-ignore
                if (optionA[optionFilter]?.toLowerCase && optionB[optionFilter]?.toLowerCase) {
                  // @ts-ignore
                  return optionA[optionFilter].toLowerCase().localeCompare(optionB[optionFilter].toLowerCase());
                }
              }

              return undefined;
            }
      }
      // maxTagCount={maxTagCount}
      {...innerProps}
    >
      {children}
    </Select>
  );
};

export default SearchableSelect;
